import React, { useEffect } from 'react'

function CommodityElements({ commodityData }) {
    const [keys, setKeys] = React.useState([]);

    const commodityKeyMap = [
        { commodity: "Single Species Hay", key: ["Single_Species_Hay"] },
        { commodity: "Mixed Species Hay", key: ["Single_Species_Hay"] },
        { commodity: "Straw", key: ["Straw_Variety",] },
        // {commodity: "Silage & Haylage", key: ["Silage_Haylage"]},
        // {commodity: "Grain", key: ["Grain"]},
        // {commodity: "Oilseed", key: ["Oilseed"]},
        // {commodity: "Pulses", key: ["Pulses"]},
        // {commodity: "Other", key: ["Other"]},
        // {commodity: "Ration", key: ["Other"]},
        // {commodity: "Other1", key: ["Other1"]}
    ]

    useEffect(() => {
        if (!commodityData) {
            setKeys([]);
            return;
        }
        const hasSelectCommodity = commodityData?.Select_Commodity !== undefined && commodityData?.Select_Commodity !== null && commodityData?.Select_Commodity !== "" && (commodityData?.Select_Commodity === "Hay" || commodityData?.Select_Commodity === "Straw");
        if (hasSelectCommodity) {
            console.log("Has Select: ", hasSelectCommodity)
            setKeys(["Sub_Category_2"]);
        } else {
            const currentComm = commodityData?.Commodity || "";
            const commLower = currentComm.toLowerCase();
            const keyMap = commodityKeyMap.find(item => item.commodity.toLowerCase() === commLower);
            if (keyMap) {
                setKeys(keyMap.key);
            } else {
                setKeys([]);
            }
        }
    }, [commodityData])

    console.log(keys)
    console.log("Select Commodity: ", commodityData?.Select_Commodity)
    console.log("Commodity: ", commodityData?.Commodity)
    console.log("Species: ", commodityData?.["Sub_Category_2"])


    return (
        <>
            <div className='grid grid-cols-1 xl:grid-cols-2 text-xs gap-x-5 gap-y-2 mt-3 py-1'>
                {
                    keys.map((key, idx) => (
                        <div key={idx} className='flex items-center space-x-3 justify-between'>
                            <span className='text-nowrap'>{key === "Sub_Category_2" ? "Species" : key.replaceAll("_", " ")}:</span>
                            <div className='w-fit p-1 outline-none rounded-sm text-center' >
                                {commodityData[key] ?? commodityData[key.replaceAll(" ", "_")] ?? "---"}
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default CommodityElements